__turbopack_context__.v({
  "container": "dot-field-module__iqF-9W__container",
  "containerInner": "dot-field-module__iqF-9W__containerInner",
  "dot": "dot-field-module__iqF-9W__dot",
});
